import React, { useContext, useEffect, useMemo } from 'react';
import { useIntl } from 'umi';
import { StudioContext } from '@home/pages/studio/context';
import { buriedPointGame } from '@home/utils/buriedPoint';
import { ConfigProvider } from 'tea-component';
import StudioState from '../../components/StudioState';
import { LANGUAGE_EN } from '@home/_config/config';

interface IProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  config?: any;
};

export default function OpinonsWrap(props: IProps) {
  const { className, style, config, children } = props;
  const { currentGame, menuPermission } = useContext(StudioContext);

  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const gameInfo = useMemo(() => {
    const {
      unified_edition_id: edition_unified_id,
      id_type,
      game_type: entity_type,
    } = currentGame || {};

    return {
      edition_unified_id,
      id_type,
      entity_type,
    };
  }, [currentGame]);

  const wholeGameInfo = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { dashboard_list, ...rest } = currentGame;
    return {
      ...rest,
      entity_name: isEn ? currentGame?.game_name : currentGame?.game_name_cn,
    };
  }, [currentGame, isEn]);

  useEffect(() => {
    const { unified_edition_id: gameid } =
      currentGame || {};
    buriedPointGame({gameName: currentGame?.game_name, ...config?.logConfig}, gameid, 'unified_id');
  }, [currentGame]);

  useEffect(() => {
    // 设置全局样式
    const element = document.querySelector('.dbh-studio-context');
    if (element && menuPermission === true) {
      (element as HTMLElement).style.backgroundColor = '#ebecf1';
    }
    return () => {
      // 去掉全局样式
      if (element) {
        (element as HTMLElement).style.backgroundColor = '#fff';
      }
    };
  }, [menuPermission]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }

  return <div key={gameInfo.id_type + gameInfo.edition_unified_id + gameInfo.entity_type} className={className} style={style}>
    <ConfigProvider locale={locale === 'zh-CN' ? 'zh' : "en"}>
      {
        children && React.Children.map(children, child => React.cloneElement(child, {
          gameInfo,
          wholeGameInfo,
        }))
      }
    </ConfigProvider>
  </div>;
}
